import { combineReducers } from 'redux';
import { PortfolioReturnsActionPayload } from './actions';
import { PortfolioReturnsWidgetState } from './PortfolioReturnsWidgetState';
import { WidgetType } from 'widgets/WidgetType';

import { buildPortfolioReturnsComponentSlice } from 'widgets/portfolioReturns/store/component/componentSlice';
import { buildPortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import { buildPortfolioReturnsStreamSlice } from 'widgets/portfolioReturns/store/stream/streamSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: componentReducer } = buildPortfolioReturnsComponentSlice();
const { reducer: configReducer } = buildPortfolioReturnsConfigSlice();
const { reducer: streamReducer } = buildPortfolioReturnsStreamSlice();

const widgetStateReducer = combineReducers<PortfolioReturnsWidgetState>({
    stream: streamReducer,
    config: configReducer,
    component: componentReducer,
});

export const portfolioReturnsWidgetsReducer = createWidgetsReducer<
    PortfolioReturnsWidgetState,
    PortfolioReturnsActionPayload
>(WidgetType.PORTFOLIO_RETURNS, widgetStateReducer);
